import { render } from "./Register_1.vue?vue&type=template&id=df1cde6e&scoped=true"
import script from "./Register_1.vue?vue&type=script&lang=js"
export * from "./Register_1.vue?vue&type=script&lang=js"

import "./Register_1.vue?vue&type=style&index=0&id=df1cde6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-register-student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1cde6e"]])

export default __exports__